import { useState } from "react";
import { Post } from './Post';
import { Gtag } from './Analytics';

// ご利用エリア外のときの「利用可能になったら通知を受け取る」フォーム（2026-09-03 共通化）。
// もとは RegisterPostcode.jsx 内にあった自前フォーム(/auth/area_waitlist.php・旧Googleフォーム置換)を
// 個人情報入力(RegisterProfile)でエリア外と判定されたケースでも同じ導線にするため切り出した。
// - postcode: 入力済みの郵便番号を引き継ぐ（area_waitlist の集計キー）
// - showMansion: 登録完了後にマンション版LPへの送客ブロックを出す（郵便番号画面のみ）
export const AreaWaitlist = ({ postcode, showMansion = false }) => {
  const [notifyContact, setNotifyContact] = useState('');
  const [notifyState, setNotifyState] = useState('');   // '' | 'sending' | 'done' | 'error'
  const [notifyError, setNotifyError] = useState('');
  const zip = String(postcode || '').replace(/-/g, '');

  async function submitNotify() {
    if (notifyState === 'sending') return;
    setNotifyState('sending');
    setNotifyError('');
    Gtag('request_mail_within_service_area', { postcode: zip });
    const res = await Post('public', '/auth/area_waitlist.php', {
      key: 'yt~z7ESU6J~tLB7ppw(CLD8WddX9PNsr6DH',
      postcode: zip,
      contact: notifyContact.trim(),
    });
    if (res && res.result === 1) {
      setNotifyState('done');
    } else {
      setNotifyState('error');
      setNotifyError(res?.error_message || '登録に失敗しました。時間をおいてお試しください');
    }
  }

  return (
    <div className="mt-2 mb-4 border rounded p-3 text-left">
      <div className="mb-2 h6">
        ご利用エリア外です
      </div>
      {notifyState === 'done' ? (
        <div>
          <div className="text-success mb-3">
            ご登録ありがとうございます。<br />
            このエリアでご利用いただけるようになりましたら、ご連絡いたします。
          </div>
          {/* マンション版への送客: エリア外でも自宅マンションに設置済みの可能性がある。
              utm付きで送り、マンション側の顧客分析(獲得チャネル)で now_area_out として追える */}
          {showMansion && (
            <div className="border-top pt-3">
              <div className="mb-2" style={{ fontSize: 13 }}>
                <b>ご自宅がマンションの方へ</b><br />
                お住まいのマンションで、ランドリーパックの宅配クリーニングがすでにご利用いただける場合があります。<br />
                <span className="text-danger">※マンション向けサービスは、対応マンションに<b>お住まいの方専用</b>です。お住まい以外のマンションではご利用いただけません。</span>
              </div>
              <button
                className="btn btn-sm btn-oval btn-black w-100"
                onClick={() => {
                  Gtag('to_mansion_lp_from_area_out', { postcode: zip });
                  // zip= で入力済み郵便番号を引き継ぎ、LPの地図がその近辺を初期表示する
                  window.open(`https://lp.laundrypack.app/mansion/?utm_source=now_app&utm_medium=referral&utm_campaign=now_area_out&zip=${encodeURIComponent(zip)}`, '_blank');
                }}
              >
                対応マンションを確認する
              </button>
            </div>
          )}
        </div>
      ) : (
        <>
          <div className="mb-2" style={{ fontSize: 13 }}>
            ご利用いただけるようになりましたら、ご連絡いたします。<br />
            メールアドレスをご登録ください（お持ちでない場合は携帯電話番号でも結構です）。
          </div>
          <input
            type="email"
            inputMode="email"
            value={notifyContact}
            onChange={(e) => { setNotifyContact(e.target.value); if (notifyState === 'error') setNotifyState(''); }}
            placeholder="メールアドレス（推奨）"
            className="form-control mb-2"
          />
          {notifyState === 'error' && (
            <div className="text-danger mb-2" style={{ fontSize: 13 }}>{notifyError}</div>
          )}
          <button
            className="btn btn-sm btn-oval btn-black w-100"
            onClick={submitNotify}
            disabled={notifyContact.trim().length < 6 || notifyState === 'sending'}
          >
            {notifyState === 'sending' ? '登録中…' : '利用可能になったら通知を受け取る'}
          </button>
        </>
      )}
    </div>
  );
};
